import { createSlice } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import { AdminSingInApi } from "../../reduxApi/SingIn&SingUp/AdminSinginApi";

const initialState = {
  status: "idle",
  AdminSingIn: null,
  error: null,
};

const AdminSingInSlice = createSlice({
  name: "AdminSingIn",
  initialState,
  reducers: {
    logout: (state) => {
      state.AdminSingIn = null;
      state.status = "idle";
      persistStore(state.AdminSingIn).purge(); // Clears persisted data on logout
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AdminSingInApi.pending, (state) => {
        state.status = "pending";
      })
      .addCase(AdminSingInApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.AdminSingIn = action.payload.data;
        console.log("Admin Sign In Response:", state.AdminSingIn);
      })
      .addCase(AdminSingInApi.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.error.message;
      });
  },
});

export const { logout } = AdminSingInSlice.actions;
export default AdminSingInSlice.reducer;
